module.exports = {
	customSprite: '/assets/icons/custom-sprite/svg/symbols.svg',
	doctypeSprite: '/assets/icons/doctype-sprite/svg/symbols.svg',
	standardSprite: '/assets/icons/standard-sprite/svg/symbols.svg',
	actionSprite: '/assets/icons/action-sprite/svg/symbols.svg',
	utilitySprite: '/assets/icons/utility-sprite/svg/symbols.svg',
};
